import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function AboutComponent() {
  return (
    <div id="about">
      <Container className="about">
        <Row>
          <Col xs={12} md={6} className="about-img">
            <img
              src="https://images.pexels.com/photos/2208891/pexels-photo-2208891.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
              className="img-fluid shadow"
              alt="..."
            />
          </Col>
          <Col xs={12} md={6} className="about-details">
            <div>
              <h1>About</h1>
              <h3>Ruhi Enterprise</h3>
              <p>
                Authorised dealer of world no 1 kitchen chimney, elica &
                introlink moduler kitchen.
              </p>
              <p>
                *This is where we spend our happiness moments and where we the
                joy of being a family. We are here to fulfill your dreams. We
                provide superior quality Home Appliances like Kent, Hindware,
                Elica etc etc and world no 1 Modular Kitchen Introlink. We want
                to provide our best products as well as services. We would like
                to inform you that we are very much conscious about after sales
                services. Our expertise will guide you to full fill your by our
                guidance according with your budget. Because we want to make you
                smile with your beautiful house. Please get in touch in below
                mentioned number. We are always happy to help you . 😊
              </p>
              <button className="btn btn-custom">Contact Us</button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AboutComponent;
